(function($) {
	$(document).ready(function() {
		var $win = $(window),
			$body = $("body");
			// $ = jQuery;
		
		// $(".nav-subscribe").on("click", function () {
		//   $("#ae-cform-modal-display-cta-2").trigger("click");
		// });
		
		// $('#umg-live-gigs-table tr').each(function(event){
		// 	// $(this).children().slice(0, 3).wrapAll('<div class="umg-locations"/>')
		// 	$(this).children().slice(3).wrapAll('<div class="umg_tickets"/>')
		// })	
		
			// Remove empty P tags created by WP inside of Accordion and Orbit
			$(".accordion p:empty, .orbit p:empty").remove();

			// Adds Flex Video to YouTube and Vimeo Embeds
			$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(
				function () {
					if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
					$(this).wrap("<div class='widescreen responsive-embed'/>");
					} else {
					$(this).wrap("<div class='responsive-embed'/>");
					}
				}
			);

		// $(window).on("scroll", function() {
		//   if($(window).scrollTop() > 50) {
		//       $(".top-bar").addClass("scrolled");
		//   } else {
		//       //remove the background property so it comes transparent again (defined in your css)
		//      $(".top-bar").removeClass("scrolled");
		//   }
		// });

		if( $body.hasClass('page-apply') ) {
			$('.cta .btn').click(function () {
				var checked = $('.opt-item input[type=checkbox]:checked').length;

				if (checked > 1) {
				window.open(
					'https://a2ksubmission.castingcrane.com/',
					'_blank'
				);
				return true;
				} else {
				if ($('.opt-item input[type=checkbox]').not(':checked').length) {
					$('.opt-item input[type=checkbox]').not(':checked').parent().addClass('invalid');
				}
				if ($('.opt-item input[type=checkbox]').is(':checked').length) {
					$('.opt-item input[type=checkbox]').not(':checked').parent().removClass('invalid');

					console.log('removed?? lag??')
				}
				return false;
				}
			});
		} // apply

		if( $body.hasClass('page-faq') ) {
			$('.faq').on('click', function(){
				$('.faq').removeClass('open');
				$(this).addClass('open');
			});
		} // faq

		$(window).on("load", function () {
			$("#ae-cform-input-reg-email-1").attr("placeholder", "Email:");

			$(".top-bar .menu-bars").on("click", function () {
				$(this).find(".fas").toggleClass("fa-times");
			});

			$(".js-off-canvas-overlay").on("click", function () {
				$(".top-bar .menu-bars .fas").removeClass("fa-times");
			});

			$(".js-subscribe a").on("click", function (e) {
				e.preventDefault();

				var $target = $(this).attr("href");

				$("html, body").animate({
					scrollTop: $($target).offset().top,
				}, 800);

				if ($(this).parents(".off-canvas")) {
					$(".js-off-canvas-overlay").trigger("click");
				}
			});

			if ($body.hasClass("home")) {
				var $h2_title = $('.main-logo h2');
				$h2_title.attr('data-title', $h2_title.text());

				// $('.js-about-title').html(function(){	
				//   // separate the text by spaces
				//   var text= $(this).text().split(' ');
				//   // drop the last word and store it in a variable
				//   var last = text.pop();
				//   // join the text back and if it has more than 1 word add the span tag
				//   // to the last word
				//   return text.join(" ") + (text.length > 0 ? ' <span>'+last+'</span>' : last);   
				// });

				$(".main-home .section").each(function () {
				var self = $(this);

					$(this).waypoint({
						handler: function (direction) {
						// if(direction == 'down') {
						// }

						// $('.main-home .section').removeClass('show');
						self.addClass("show");
						},
						offset: "50%",
					});
				});

				// if ($win.width() < 480) {
				//   var waypoints = $(".section-about").waypoint({
				//     handler: function (direction) {
				//       if (direction == "up") {
				//         $("#top-bar-menu .logo").removeClass("show");
				//       } else {
				//         $("#top-bar-menu .logo").addClass("show");
				//       }
				//     },
				//     offset: "0",
				//   });
				// }
			}
		});
  	});
})(jQuery);